import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { FramingBand } from './components/FramingBand';
import { ProblemSection } from './components/ProblemSection';
import { PlatformOverview } from './components/PlatformOverview';
import { OperatingModel } from './components/OperatingModel';
import { CapabilityDomains } from './components/CapabilityDomains';
import { HumanOpportunity } from './components/HumanOpportunity';
import { LifecycleArchitecture } from './components/LifecycleArchitecture';
import { Solutions } from './components/Solutions';
import { ProductEcosystem } from './components/ProductEcosystem';
import { GlobalArchitecture } from './components/GlobalArchitecture';
import { LeadershipReadiness } from './components/LeadershipReadiness';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CJIPage } from './components/CJIPage';
import { NCJIPage } from './components/NCJIPage';
import { SolutionsPage } from './components/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './components/ResearchPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { ContactPage } from './components/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './components/GovernmentPage';
import { EducationPage } from './components/EducationPage';
import { EmployersPage } from './components/EmployersPage';
import { CivilSocietyPage } from './components/CivilSocietyPage';
import { LeadershipPage } from './components/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setCurrentPage(hash);
      window.scrollTo(0, 0);
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'cji':
        return <>
            <CJIPage data-id="element-0" />
            <FinalCTA data-id="element-1" />
          </>;
      case 'ncji':
        return <>
            <NCJIPage data-id="element-2" />
            <FinalCTA data-id="element-3" />
          </>;
      case 'solutions':
        return <>
            <SolutionsPage data-id="element-4" />
            <FinalCTA data-id="element-5" />
          </>;
      case 'about':
        return <>
            <AboutPage data-id="element-6" />
            <FinalCTA data-id="element-7" />
          </>;
      case 'research':
        return <>
            <ResearchPage data-id="element-8" />
            <FinalCTA data-id="element-9" />
          </>;
      case 'partnerships':
        return <>
            <PartnershipsPage data-id="element-10" />
            <FinalCTA data-id="element-11" />
          </>;
      case 'contact':
        return <>
            <ContactPage data-id="element-12" />
            <FinalCTA data-id="element-13" />
          </>;
      case 'privacy':
        return <PrivacyPolicyPage data-id="element-14" />;
      case 'terms':
        return <TermsOfServicePage data-id="element-15" />;
      case 'government':
        return <>
            <GovernmentPage data-id="element-16" />
            <FinalCTA data-id="element-17" />
          </>;
      case 'education':
        return <>
            <EducationPage data-id="element-18" />
            <FinalCTA data-id="element-19" />
          </>;
      case 'employers':
        return <>
            <EmployersPage data-id="element-20" />
            <FinalCTA data-id="element-21" />
          </>;
      case 'civil-society':
        return <>
            <CivilSocietyPage data-id="element-22" />
            <FinalCTA data-id="element-23" />
          </>;
      case 'leadership':
        return <>
            <LeadershipPage data-id="element-24" />
            <FinalCTA data-id="element-25" />
          </>;
      case 'reasoning-quality':
        return <>
            <ReasoningQualityPage data-id="element-26" />
            <FinalCTA data-id="element-27" />
          </>;
      case 'consequential-thinking':
        return <>
            <ConsequentialThinkingPage data-id="element-28" />
            <FinalCTA data-id="element-29" />
          </>;
      case 'manipulation-resistance':
        return <>
            <ManipulationResistancePage data-id="element-30" />
            <FinalCTA data-id="element-31" />
          </>;
      case 'emotional-regulation':
        return <>
            <EmotionalRegulationPage data-id="element-32" />
            <FinalCTA data-id="element-33" />
          </>;
      case 'social-cooperation':
        return <>
            <SocialCooperationPage data-id="element-34" />
            <FinalCTA data-id="element-35" />
          </>;
      case 'self-direction':
        return <>
            <SelfDirectionPage data-id="element-36" />
            <FinalCTA data-id="element-37" />
          </>;
      case 'leadership-responsibility':
        return <>
            <LeadershipResponsibilityPage data-id="element-38" />
            <FinalCTA data-id="element-39" />
          </>;
      case 'home':
      default:
        return <>
            <HeroSection data-id="element-40" />
            <FramingBand data-id="element-41" />
            <ProblemSection data-id="element-42" />
            <PlatformOverview data-id="element-43" />
            <OperatingModel data-id="element-44" />
            <CapabilityDomains data-id="element-45" />
            <HumanOpportunity data-id="element-46" />
            <LifecycleArchitecture data-id="element-47" />
            <Solutions data-id="element-48" />
            <ProductEcosystem data-id="element-49" />
            <GlobalArchitecture data-id="element-50" />
            <LeadershipReadiness data-id="element-51" />
            <FAQ data-id="element-52" />
            <FinalCTA data-id="element-53" />
          </>;
    }
  };
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-54">
      <Navigation data-id="element-55" />
      <main data-id="element-56">{renderPage()}</main>
      <Footer data-id="element-57" />
    </div>;
}